module.exports = __webpack_public_path__ + "img/icon_list_seller_pre.d1e731b2.png";